export interface Faqs {
  experiment: boolean;
  question: string;
  answer: string;
  region: string[];
}
export const plansFaqs: Faqs[] = [
  {
    experiment: true,
    question: 'How do monthly downloads work?',
    answer:
      'On the Lite plan you have access to 3 downloads per month. This allows you to download the specific teaching content you want at a reduced overall price. Your available downloads will reset on the 1st of each month. These downloads do not accrue, so to get the most out of your plan come back to browse our new resources each month!',
    region: ['us'],
  },
  {
    experiment: true,
    question: 'What’s the difference between Plus and Lite?',
    answer:
      'The Plus plan has full unlimited access to our entire library of teaching resources. While the Lite plan has the same access to all of our content but has a limitation of 3 downloads per month.',
    region: ['us'],
  },
  {
    experiment: false,
    question: 'Can I cancel my subscription at any time?',
    answer:
      "Yes. If you ever decide that Teach Starter isn't the best teaching resource for your classroom or home, simply cancel your account in 'Account Settings', or contact us for help. Even after cancelling your subscription, you'll still have access to Plus Plan resources for the remainder of your subscription period.",
    region: ['au', 'us', 'gb'],
  },
  {
    experiment: false,
    question: "Can I join a School Plan while I'm on Plus?",
    answer:
      "Absolutely! We'll even credit your account based on the remaining time on your Plus subscription.",
    region: ['au', 'us', 'gb'],
  },
  {
    experiment: false,
    question: 'Is my subscription tax deductible?',
    answer:
      'Your Teach Starter subscription may be tax deductible! Check with your tax specialist to find out.',
    region: ['us', 'au', 'gb'],
  },
  {
    experiment: false,
    question: 'How do I pay for my subscription?',
    answer:
      'You can pay for your subscription securely via credit card or PayPal. Purchase orders are also available for School Plans.',
    region: ['au', 'us', 'gb'],
  },
  {
    experiment: false,
    question: 'How long will I have access to my resources?',
    answer:
      'With the Plus Plan, you will have access to the Teach Starter library for the entire length of your subscription. During that time, you can use any of the site’s vast collection of digital and printable resources, plus our custom widgets, word lists, unit and lesson plans and more. Access to Teach Starter’s digital tools expire at the end of a subscription.',
    region: ['au', 'us', 'gb'],
  },
];
export default plansFaqs;
